// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { endpoints } from '../../api/endpoints';
import { RootState } from '../index';

type PlayerInfoResult = {
  data: {
    level: string;
    points: string;
  };
  success: boolean;
};

type PlayerInfoError = {
  rejectValue: {
    error: string;
  };
};

export const fetchPlayerInfo = createAsyncThunk<PlayerInfoResult, void, PlayerInfoError>(
  'retailPlayerInfo/fetch',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state: RootState = getState() as RootState;

      if (!state.authentication.access_token || state.authentication.auth_type !== 'user') {
        return rejectWithValue({
          error: 'Authentication token is missing or invalid',
        });
      }

      const response = await axios.get(endpoints.retailPlayerInfo.fetch, {
        headers: {
          Authorization: 'Bearer ' + state.authentication.access_token,
        },
      });

      if (response.data) {
        return { data: response.data, success: true };
      }

      return rejectWithValue({
        error: "Couldn't fetch player info",
      });
    } catch (err: any) {
      const errResp = { error: err.toString() };
      return rejectWithValue(errResp);
    }
  },
);

export interface RetailPlayerInfo {
  level: string | null;
  points: string | null;
  loading: boolean;
  error: any;
}

export const retailPlayerInfoSlice = createSlice({
  name: 'retailPlayerInfo',
  initialState: <RetailPlayerInfo>{
    level: null,
    points: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlayerInfo.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.success) {
          state.level = action.payload.data.level ?? null;
          state.points = action.payload.data.points ?? false;
        }
        console.log('fetchPlayerInfo.fulfilled', action.payload, state);
      })
      .addCase(fetchPlayerInfo.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPlayerInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.error;
        console.log('fetchPlayerInfo.rejected', action.payload);
      });
  },
});

export const { clearError } = retailPlayerInfoSlice.actions;

export default retailPlayerInfoSlice.reducer;
